import React from "react";
import { motion } from "framer-motion";
import "./FeatureSection.css";

const features = [
 {
  title: "Logo Design",
  desc: "Create a distinctive and memorable brand identity with a logo designed to reflect your vision, values, and market positioning.",
},
{
  title: "Packaging Design",
  desc: "Eye-catching packaging that communicates your brand story, enhances shelf appeal, and influences purchasing decisions.",
},
{
  title: "Website Design",
  desc: "Modern, responsive websites crafted to deliver seamless user experiences and convert visitors into customers.",
},
{
  title: "Social Media",
  desc: "Strategic content and visuals designed to grow engagement, build trust, and strengthen your brand presence online.",
},

];

const headingVariants = {
  hidden: { opacity: 0, x: -40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: i => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Service = () => {
  return (
    <section id="Services"  className="features-floating">

      <div className="features-container">

        {/* LEFT CONTENT */}
        <motion.div
          className="features-left"
          variants={headingVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h2>Our Services Brings Outstanding </h2>
          <h3>
            Designing Experiences That Make Brands Stand Out
          </h3>
        </motion.div>

        {/* RIGHT GRID */}
        <div className="features-grid">
          {features.map((item, index) => (
            <motion.div
              key={index}
              className="feature-card"
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              whileHover={{
                scale: 1.05,
                y: -8,
              }}
            >
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>

      </div>

    </section>
  );
};

export default Service;
